/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_How_TriggersInputs */



/**
* | output |
* | --- |
* | "When it runs" |
*
* @param {Agent_Wizard_How_TriggersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_how_triggers = /** @type {((inputs?: Agent_Wizard_How_TriggersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_How_TriggersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auslöser")
	return /** @type {LocalizedString} */ ("When it runs")
});